
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ProgressParams } from '@/types'
import FrameAnime from '@bilibili-activity/frame-animation';

@Component({
  name: 'Progress',
})
export default class Progress extends Vue {
  @Prop({
    default: '#ff3333',
    required: false,
  })
  color!: string
  @Prop({
    default: 200,
    required: false,
  })
  width!: number
  @Prop({
    default: 25,
    required: false,
  })
  percent!: number

  @Prop({
    default: 'pc',
    required: false,
  })
  type!: string

  @Prop({
    default: [],
    required: false,
  })
  list!: ProgressParams[]


  anime!: FrameAnime;
  setPosition() {
    console.log('this.percent', this.percent)
    return {
      'left': this.percent + '%',
    }
  }
  async mounted() {
    const animeDom = document.getElementsByClassName(
        'progress-animate'
    )[0] as HTMLDivElement;
    this.anime = new FrameAnime({ // png 序列动画
      frame: 119,
      url: '//i0.hdslb.com/bfs/activity-plat/static/20230905/ed208e0685394224eb0049ea11d67202/a52jvZ16No.png',
      duration: 4000,
      el: animeDom,
      column: 1,
    });
    await this.anime.init();
    this.anime.setFrame(119);
    this.anime.play()
  }
}
